import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Game.css";

const GAME_URL =
  "https://pub-61cd66943e494fc9be85905c21d456ee.r2.dev/game.html";

export default function Game() {
  const navigate = useNavigate();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    console.log("=== DATI GIOCATORE ===");
    console.log("Nome:", sessionStorage.getItem("playerName"));
    console.log("Personaggio:", sessionStorage.getItem("selectedChampion"));
    console.log("Email:", sessionStorage.getItem("playerEmail"));
    console.log("====================");

    const handleMessage = (event: MessageEvent) => {
      // Verifica che il messaggio provenga dal dominio del gioco
      if (!event.origin.includes("r2.dev")) {
        return;
      }

      console.log("Messaggio ricevuto dall'iframe:", event.data);

      // Quando Godot è pronto, invia i dati del session storage
      if (event.data.type === "GODOT_READY") {
        console.log("Godot engine is ready - invio dati giocatore");

        const playerData = {
          type: "PLAYER_DATA",
          playerName: sessionStorage.getItem("playerName"),
          selectedChampion: sessionStorage.getItem("selectedChampion"),
          playerEmail: sessionStorage.getItem("playerEmail"),
        };

        console.log("Invio dati:", playerData);
        iframeRef.current?.contentWindow?.postMessage(playerData, GAME_URL);
      }

      // Gestisci il redirect a /ranking
      if (event.data.type === "NAVIGATE_TO_RANKING") {
        console.log("Richiesta di navigazione a /ranking dall'iframe");
        navigate("/ranking");
      }

      // Gestisci richieste di lettura dello storage
      if (event.data.type === "GET_SESSION_STORAGE") {
        const key = event.data.key;
        const value = sessionStorage.getItem(key);
        iframeRef.current?.contentWindow?.postMessage(
          {
            type: "SESSION_STORAGE_RESPONSE",
            key: key,
            value: value,
          },
          GAME_URL
        );
      }

      if (event.data.type === "GET_LOCAL_STORAGE") {
        const key = event.data.key;
        const value = localStorage.getItem(key);
        iframeRef.current?.contentWindow?.postMessage(
          {
            type: "LOCAL_STORAGE_RESPONSE",
            key: key,
            value: value,
          },
          GAME_URL
        );
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  return (
    <div className="game-wrapper">
      <iframe
        ref={iframeRef}
        src={GAME_URL}
        title="Napoli Basketball Game"
        width="100%"
        height="100%"
        allowFullScreen
        loading="lazy"
        allow="storage-access"
      />
    </div>
  );
}
